import { builtinRules } from "eslint/use-at-your-own-risk";
const rule = builtinRules.get("no-undef")!;

export default rule;
